import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  TextField,
  ListItem,
  IconButton,
  ListItemIcon,
} from "@material-ui/core";
import ModalCardAdmin from "./ModalCardAdmin";
import serviciosTablero from "utils/serviciosTablero";
import Descripcion from "./ModalContent/Descripcion";
import ListIcon from "@material-ui/icons/List";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { makeStyles } from "@material-ui/core/styles";
import iconExcel from "../../../assets/excel.png";
import iconPDF from "../../../assets/pdf.png";
import iconWord from "../../../assets/word.png";
import iconImage from "../../../assets/imagen.png";
import DescriptionIcon from "@material-ui/icons/Description";


const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4, 6),
    borderRadius: "8px",
    outline: "none",

  },
  fileInput: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));
const titleStyle = {
  display: "flex",
  alignItems: "center",
};
const TarjetaAdmin = ({
  open,
  onClose,
  titulo,
  props,
  infoTablero,
  tarjeta,
  setCargando,
  dataEtapa,
}) => {
  const classesTablero = useStylesTablero();
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [adjunto, setAdjunto] = useState([]);
  const [fechaFormateada, setFechaFormateada] = useState("");

  const getSolicitud = () => {

    serviciosTablero.getInformacionGeneral(
      (status, mensaje, data) => {
        if (status === 1) {
          setData(data);
        } else {
          console.error("Error al cargar adjuntos:", mensaje);
        }
      },
      setCargando,
      { idtarjeta: tarjeta }
    );
  };
  const getFileIcon = (mimeType) => {
    switch (mimeType) {
      case "application/pdf":
        return (
          <img
            src={iconPDF}
            alt="PDF Icon"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "image/jpeg":
      case "image/png":
      case "image/gif":
        return (
          <img
            src={iconImage}
            alt="Image Icon"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      case "application/vnd.ms-excel":
        return (
          <img
            src={iconExcel}
            alt="Excel Icon"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return (
          <img
            src={iconWord}
            alt="Word Icon"
            style={{ width: "50px", height: "50px" }}
          />
        );
      default:
        return <DescriptionIcon />;
    }
  };
  const getSolicitudArchivos = () => {
    serviciosTablero.getDocumentacionSolicitud(
      (status, mensaje, data) => {
        if (status === 1) {
          setAdjunto(data);
        } else {
          console.error("Error al cargar adjuntos:", mensaje);
        }
      },
      setCargando,
      { idsolicitud: props?.data?.idsolicitud }
    );
  };
  const handleIconClick = (archivo) => {
    if (archivo?.url) {
      // Crear un enlace temporal
      const link = document.createElement("a");
      link.href = archivo.url;
      link.download = "archivo"; // Puedes personalizar el nombre del archivo aquí
      document.body.appendChild(link);
      // Simular el clic para descargar
      link.click();
      // Eliminar el enlace temporal
      document.body.removeChild(link);
    } else if (archivo?.ruta) {
      const link = document.createElement("a");
      link.href = archivo.ruta;
      link.download = "archivo"; // Puedes personalizar el nombre del archivo aquí
      document.body.appendChild(link);
      // Simular el clic para descargar
      link.click();
      // Eliminar el enlace temporal
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    if (open) {
      getSolicitud();
      getSolicitudArchivos();
    }
  }, [open]);
  useEffect(() => {
    if (data?.fcrea) {
      // Convertir la fecha del estado al formato YYYY-MM-DD
      const fechaObj = new Date(data?.fcrea);
      const anio = fechaObj.getFullYear();
      const mes = (fechaObj.getMonth() + 1).toString().padStart(2, "0"); // Mes comienza desde 0
      const dia = fechaObj
        .getDate()
        .toString()
        .padStart(2, "0");
      setFechaFormateada(`${anio}-${mes}-${dia}`);
    }
  }, [data?.fcrea]);
  return (
    <ModalCardAdmin
      open={open}
      onClose={onClose}
      titulo={titulo}
      props={props}
      data={data}
      dataEtapa={dataEtapa}
    >
      <Grid container spacing={1}>
        <Grid item sm={12} xs={12}>
          <Grid>
            <TextField
              fullWidth
              variant="outlined"
              label="Descripción"
              multiline
              value={data?.desc_solicitud ? data?.desc_solicitud : ""}
              className={classesTablero.field}
              style={{ marginTop: 6 }}
            />
            <Box sx={titleStyle}>
              <ListIcon sx={{ marginRight: 1 }} style={{ color: "#CCCCCC" }} />
              <Typography
                variant="h6"
                component="h2"
                style={{ color: "#CCCCCC" }}
              >
                Datos Generales
              </Typography>
            </Box>
            <Grid container spacing={2} style={{ marginBottom: 4 }}>
              <Grid item sm={4} sx={12}>
                <TextField
                  id="solicitante"
                  label={"Solicitante"}
                  variant="outlined"
                  value={data?.solicitante}
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{
                    shrink: true, // Esto asegura que el label se quede arriba incluso cuando hay un valor
                  }}
                  className={classesTablero.field}
                />
              </Grid>
              <Grid item sm={4}>
                <TextField
                  id="prioridad"
                  label={"Prioridad"}
                  variant="outlined"
                  value={data?.nprioridad}
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{
                    shrink: true, // Esto asegura que el label se quede arriba incluso cuando hay un valor
                  }}
                  className={classesTablero.field}
                />
              </Grid>
              <Grid item sm={4}>
                <TextField
                  id="nombreSistema"
                  variant="outlined"
                  label={"Nombre del sistema"}
                  value={data?.sistema}
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{
                    shrink: true, // Esto asegura que el label se quede arriba incluso cuando hay un valor
                  }}
                  className={classesTablero.field}
                />
              </Grid>
              <Grid item sm={4}>
                <TextField
                  id="AreaSolicitante"
                  label={"Área"}
                  variant="outlined"
                  value={data?.area ? data.area : "SIN ESPECIFICAR"}
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{
                    shrink: true, // Esto asegura que el label se quede arriba incluso cuando hay un valor
                  }}
                  className={classesTablero.field}
                />
              </Grid>
              <Grid item sm={4}>
                <TextField
                  id="Tipo aplicacion"
                  label={"Tipo de aplicación"}
                  variant="outlined"
                  value={data?.tipo_app ? data?.tipo_app : "SIN ESPECIFICAR"}
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{
                    shrink: true, // Esto asegura que el label se quede arriba incluso cuando hay un valor
                  }}
                  className={classesTablero.field}
                />
              </Grid>
              <Grid item sm={4}>
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  label={"Fecha"}
                  value={fechaFormateada}
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{
                    shrink: true, // Esto asegura que el label se quede arriba incluso cuando hay un valor
                  }}
                  className={classesTablero.field}
                />
              </Grid>
            </Grid>
            <Box sx={titleStyle}>
              <AttachFileIcon
                sx={{ marginRight: 1 }}
                style={{ color: "#CCCCCC" }}
              />
              <Typography
                variant="h6"
                component="h2"
                style={{ color: "#CCCCCC" }}
              >
                Documentos
              </Typography>
            </Box>
            <Box
              className={classes.paper}
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="center" // Centra horizontalmente
              gap={2} // Espaciado entre los elementos
              sx={{
                height: "100%", // Asegura que el Box tome toda la altura del contenedor padre
                width: "100%", // Asegura que el Box tome todo el ancho del contenedor padre
              }}
            >
              {adjunto?.length > 0
                ? adjunto.map((item, itemIndex) => (
                  <Grid
                    item
                    key={itemIndex}
                    direction="row"
                    spacing={2}
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      maxWidth: "calc(20% - 12px)", // Consistencia en el ancho
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)", // Sombra más notable
                      backgroundColor: "#323940", // Fondo más oscuro
                      borderRadius: "6px", // Bordes redondeados más sutiles
                      padding: "12px", // Menor espaciado interno
                      justifyContent: "flex-start"
                    }}
                  >
                    <ListItem
                      id={`btnArchivo${item?.idarchivo}`}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        width: "100%",
                        height: "80px", // Altura más pequeña
                        borderRadius: "6px",
                        backgroundColor: "#424A54", // Fondo más claro para contraste
                      }}
                    >
                      {/* Ícono de archivo */}
                      <IconButton
                        id={`btnDescargarArchivo${item?.idarchivo}`}
                        onClick={() => handleIconClick(item)}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <ListItemIcon
                          style={{
                            fontSize: "16px", // Ícono más pequeño
                            justifyContent: "center",
                            color: "#FFF", // Íconos en blanco para resaltar en el fondo oscuro
                          }}
                        >
                          {getFileIcon(item.mimeType)}
                        </ListItemIcon>
                      </IconButton>

                      {/* Nombre del archivo */}
                      <Typography
                        variant="caption"
                        style={{
                          textAlign: "center",
                          marginTop: "4px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap", // Evita que el texto se desborde
                          width: "80%", // Ancho limitado para diseño compacto
                          color: "#FFF", // Texto blanco para contraste
                          fontSize: "10px", // Fuente más pequeña
                        }}
                      >
                        {item?.nombre}
                      </Typography>
                    </ListItem>
                  </Grid>
                ))
                : ""}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </ModalCardAdmin>
  );
};

export default TarjetaAdmin;
